import { render, staticRenderFns } from "./MultipleAreaBase.vue?vue&type=template&id=5952db74&scoped=true&"
import script from "./MultipleAreaBase.vue?vue&type=script&lang=js&"
export * from "./MultipleAreaBase.vue?vue&type=script&lang=js&"
import style0 from "./MultipleAreaBase.vue?vue&type=style&index=0&id=5952db74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5952db74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
